/*
 * <license header>
 */

import React, { useEffect, useState } from 'react';

import {
  Form,
  TextField,
  Button, // , Menu, Item, MenuTrigger, ActionButton, Button,
  Picker,
  Item,
} from '@adobe/react-spectrum';
import PropTypes from 'prop-types';

import PageSectionDivider from '../../../components/Layout/Content/PageSectionDivider';
import actionWebInvoke from '../../../utils/actionCallUtils';
import getHeaders from '../../../utils/headers';
import actions from '../../../config.json';

const AdminScreen = props => {
  const [userIdValue, setUserIdValue] = useState('');
  const [requestProjectIdValue, setRequestProjectIdValue] = useState('');
  const [wfEndpointValue, setWfEndpointValue] = useState('');
  const [wfApiKeyValue, setWfApiKeyValue] = useState('');
  const [wfSysUserIDValue, setWfSysUserIDValue] = useState('');
  const [aemEndpointValue, setAemEndpointValue] = useState('');
  const [ccLibEndpointValue, setCcLibEndpointValue] = useState('');
  const [ccLibApiKeyValue, setCcLibApiKeyValue] = useState('');
  const [stockEndpointValue, setStockEndpointValue] = useState('');
  const [stockApiKeyValue, setStockApiKeyValue] = useState('');
  const [disabled, setDisabled] = useState(true);
  const { ims, setUserID } = props;

  const [configurations, setConfigurations] = useState({
    isLoading: true,
    elements: [],
  });

  useEffect(() => {
    if (
      requestProjectIdValue.length &&
      wfEndpointValue.length &&
      wfApiKeyValue.length &&
      wfSysUserIDValue.length &&
      aemEndpointValue.length &&
      ccLibEndpointValue.length &&
      ccLibApiKeyValue.length &&
      stockEndpointValue.length &&
      stockApiKeyValue.length
    ) {
      setDisabled(false);
    } else setDisabled(true);
  }, [
    requestProjectIdValue,
    wfEndpointValue,
    wfApiKeyValue,
    wfSysUserIDValue,
    aemEndpointValue,
    ccLibEndpointValue,
    ccLibApiKeyValue,
    stockEndpointValue,
    stockApiKeyValue,
  ]);

  async function getConfigurations() {
    setConfigurations({ ...configurations, isLoading: true });
    const headers = getHeaders(ims);
    const actionResponse = await actionWebInvoke(
      actions['aio-lib-state-read'],
      headers,
      'key',
    );
    setConfigurations({
      ...configurations,
      configurations: actionResponse,
      isLoading: false,
    });
    if (actionResponse?.userId && actionResponse?.userId !== undefined)
      setUserIdValue(actionResponse.userId || '');
    if (
      actionResponse?.requestProjectId &&
      actionResponse?.requestProjectId !== undefined
    )
      setRequestProjectIdValue(actionResponse.requestProjectId || '');
    if (actionResponse?.wfEndpoint && actionResponse?.wfEndpoint !== undefined)
      setWfEndpointValue(actionResponse.wfEndpoint || '');
    if (actionResponse?.wfApiKey && actionResponse?.wfApiKey !== undefined)
      setWfApiKeyValue(actionResponse.wfApiKey || '');
    if (
      actionResponse?.wfSysUserID &&
      actionResponse?.wfSysUserID !== undefined
    )
      setWfSysUserIDValue(actionResponse.wfSysUserID || '');
    if (
      actionResponse?.aemEndpoint &&
      actionResponse?.aemEndpoint !== undefined
    )
      setAemEndpointValue(actionResponse.aemEndpoint || '');
    if (
      actionResponse?.ccLibEndpoint &&
      actionResponse?.ccLibEndpoint !== undefined
    )
      setCcLibEndpointValue(actionResponse.ccLibEndpoint || '');
    if (
      actionResponse?.ccLibApiKey &&
      actionResponse?.ccLibApiKey !== undefined
    )
      setCcLibApiKeyValue(actionResponse.ccLibApiKey || '');
    if (
      actionResponse?.stockEndpoint &&
      actionResponse?.stockEndpoint !== undefined
    )
      setStockEndpointValue(actionResponse.stockEndpoint || '');
    if (
      actionResponse?.stockApiKey &&
      actionResponse?.stockApiKey !== undefined
    )
      setStockApiKeyValue(actionResponse.stockApiKey || '');
  }

  useEffect(() => {
    getConfigurations();
  }, [ims]);
  useEffect(() => {
    if (userIdValue !== '' && userIdValue !== undefined) {
      setUserID(userIdValue);
    }
  }, [userIdValue]);

  async function setConfig() {
    const headers = getHeaders(ims);
    await actionWebInvoke(actions['aio-lib-state-write'], headers, {
      userIdValue,
      requestProjectIdValue,
      wfEndpointValue,
      wfApiKeyValue,
      wfSysUserIDValue,
      aemEndpointValue,
      ccLibEndpointValue,
      ccLibApiKeyValue,
      stockEndpointValue,
      stockApiKeyValue,
    });
  }

  const onFormSubmit = () => {
    setConfig();
  };
  const userList = [
    // {
    //   // ID: '60c7fafc0004b63c7c19400ca1b1eaf6',
    //   ID: '60c7fafc0004b63c7c19400ca1b1eaf6',
    //   name: 'Jen Woo Planner',
    // },
    // {
    //   // ID: '60c34f3c0030310b3fc6f3da21e2f387',
    //   ID: '9b6b6ba0964e410989ca9aa83122ea92',
    //   name: 'Conrad Hilton Requester',
    // },
    {
      // ID: '60c7f19900043ce928e296d62c56d5ba',
      ID: 'ee03bb52c07c4d4fa47a303cad8c8002',
      name: 'Joan Harris Project Manager',
    },
    // {
    //   // ID: 'c46d81614b190bece0534d6e760ab913',
    //   ID: 'c46d81614b190bece0534d6e760ab913',
    //   name: 'James Doolittle Worker',
    // },
    {
      // ID: '60c34f3c0030310b3fc6f3da21e2f387',
      ID: '614a0e20022291acc0ee35848cb02122',
      name: 'James Smith Author',
    },
    {
      // ID: '60c7fa230004ae2cde0963a09a6edbc8',
      ID: 'b523b8f2179648baa8a7c37f69864508',
      name: 'Rick Kuvec Designer',
    },
  ];
  return (
    <div className="adminPage">
      <div className="form">
        <Form maxWidth="size-3600" isRequired necessityIndicator="label">
          <h2 align="center">Admin Configurations</h2>
          <div>
            <Picker
              width="288px"
              label="Users"
              onSelectionChange={setUserIdValue}
              selectedKey={userIdValue}
              isRequired
            >
              {userList.map(row => (
                <Item key={row.ID}>{row.name}</Item>
              ))}
            </Picker>
            <PageSectionDivider size="S" />
          </div>
          <TextField
            label="Request Queue Project ID"
            value={requestProjectIdValue}
            onChange={setRequestProjectIdValue}
          />
          <TextField
            label="Workfront Endpoint"
            value={wfEndpointValue}
            onChange={setWfEndpointValue}
          />
          <TextField
            label="Workfront API Key"
            value={wfApiKeyValue}
            onChange={setWfApiKeyValue}
          />
          <TextField
            label="Workfront System User ID"
            value={wfSysUserIDValue}
            onChange={setWfSysUserIDValue}
          />
          <TextField
            label="AEM Endpoint"
            value={aemEndpointValue}
            onChange={setAemEndpointValue}
          />
          <TextField
            label="CC Lib Endpoint"
            value={ccLibEndpointValue}
            onChange={setCcLibEndpointValue}
          />
          <TextField
            label="CC Lib API Key"
            value={ccLibApiKeyValue}
            onChange={setCcLibApiKeyValue}
          />
          <TextField
            label="Stock Endpoint"
            value={stockEndpointValue}
            onChange={setStockEndpointValue}
          />
          <TextField
            label="Stock API key"
            value={stockApiKeyValue}
            onChange={setStockApiKeyValue}
          />
          <Button
            variant="cta"
            isDisabled={disabled}
            onPress={() => {
              onFormSubmit();
            }}
          >
            Submit
          </Button>
        </Form>
      </div>
    </div>
  );
};

AdminScreen.propTypes = {
  ims: PropTypes.shape({
    token: PropTypes.string,
    org: PropTypes.string,
  }),
};

AdminScreen.defaultProps = {
  ims: {
    token: '',
    org: '',
  },
};

export default AdminScreen;
